(function () {
  if (window.GASplide) return;

  function getNumber(value, fallback) {
    var n = parseInt(value, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function mountSplide(el) {
    if (!window.Splide || el.dataset.gasSplideMounted === 'true') return;

    var perPageDesktop = getNumber(el.dataset.perPageDesktop, 3);
    var perPageMobile = getNumber(el.dataset.perPageMobile, 1);
    var gap = el.dataset.gap || '1rem';
    var autoplay = el.dataset.autoplay === 'true';
    var loop = el.dataset.loop === 'true';
    var interval = getNumber(el.dataset.interval, 4000);
    var pagination = el.dataset.pagination === 'true';
    var arrows = el.dataset.arrows !== 'false';
    var explicitType = el.dataset.type; // 'fade', 'loop', 'slide'

    var type;
    if (explicitType === 'fade') {
      type = 'fade';
    } else {
      type = loop ? 'loop' : 'slide';
    }

    var splide = new window.Splide(el, {
      type: type,
      rewind: explicitType === 'fade',
      perPage: perPageDesktop,
      perMove: 1,
      gap: gap,
      arrows: arrows,
      pagination: pagination,
      autoplay: autoplay,
      interval: interval,
      pauseOnHover: true,
      pauseOnFocus: true,
      resetProgress: false,
      breakpoints: {
        989: {
          perPage: perPageMobile,
        },
      },
    });

    splide.mount();
    el.dataset.gasSplideMounted = 'true';
  }

  function mountWithin(root) {
    if (!root) return;
    var nodes = root.querySelectorAll('[data-gas-splide]');
    nodes.forEach(function (el) {
      mountSplide(el);
    });
  }

  window.GASplide = {
    mountWithin: mountWithin,
  };
})();
